export default __webpack_public_path__ + "static/media/Mayank-Pachpande-bg-img-edited.6bd90375.jpg";